import { useSearchParams } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import { company } from "../data/site";

export default function Jobs() {
  const [params] = useSearchParams();
  const type = params.get("tab") === "campus" ? "校园招聘" : "社会招聘";

  return (
    <div className="inner-page">
      <PageBanner title={type} en="JOBS" variant="join" />
      <section className="panel">
        <div className="container">
          <h2 className="small-title">{type}</h2>
          <div className="empty-job">
            <p>暂无岗位</p>
            <p>
              可将简历发送至
              <a href={`mailto:${company.email}`}> {company.email}</a>
              ，邮件标题请注明「应聘 + 姓名 + 方向」。
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
